export default "__VITE_ASSET__cG5hSA3A__"